import Link from "next/link";
import { downloadLink } from "@/lib/utils.js";
import ResourcesModal from "@/components/resources_modal";
import { useState } from "react";
import ShareSvg from "@/components/svgs/share_svg.js";
import DownloadSvg from "@/components/svgs/download_svg.js";
import ResourceList from "@/components/resource_list";
import BulkAssetLinks from '@/components/bulk_asset_links.js'
import CustomizableResourcesArea from '@/components/customizable_resources_area.js'

export default function ProductResources({
  downloads,
  more_about_text,
  attributes,
  product,
  resource_display,
  config
}) {
  
  return ( <CustomizableResourcesArea 
               product={product} resource_display={resource_display} config={config} 
     />  
    
  );
}
